import React, { useContext, useEffect, useState } from "react";
import { ChangeEvent } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { Snackbar, TextField, Typography } from "@mui/material";
import { TableFooter, TablePagination } from "@mui/material";
import { TableBody, TableHead } from "@mui/material";
import { TableContainer, TableCell, TableRow } from "@mui/material";
import { Box, Paper, Stack } from "@mui/material";

import { del, get, post } from "../../../Services/tokenConfig";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import { func_print } from "../../../Func_genericas/func_print";
import { ICabecalho, IPage5, IPage5Observacoes } from "../../../Interfaces/cadernos/caderno5/caderno5";
import { operacaocultural_aux, unidade_medida_mm } from "../../../informacao_estatica";
import { Alert } from "../../../Components/Alert/Alert";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { desformatarNumero_return_null, formatarNumero_ao_digitar } from "../../../Func_genericas/formatar_numero_formato_pt";
import { formatar_numeros_tabela5 } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/caderno5";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { CabecalhoForm } from "./cabecalho";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, message_apenas_numero } from "../../../Func_genericas/valores_estaticos";
import { data, useLocation } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { FilterByData } from "../../../Func_genericas/filter_by_data";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(0),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    }
  })
);

export default function RegistoOperCulturais() {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [message, setMessage] = React.useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [error_t, set_error_t] = useState<boolean>(false);
  const [error_m, set_error_m] = useState<boolean>(false);
  const [error_l, set_error_l] = useState<boolean>(false);
  const [error_k, set_error_k] = useState<boolean>(false);
  const [error_n, set_error_n] = useState<boolean>(false);
  const [error_po, set_error_po] = useState<boolean>(false);
  const [error_k2o, set_error_k2o] = useState<boolean>(false);
  const [error_mgo, set_error_mgo] = useState<boolean>(false);
  const [error_cao, set_error_cao] = useState<boolean>(false);
  const [error_so, set_error_lso] = useState<boolean>(false);


  const [idToDelete, setIdToDelete] = useState<number | undefined>();
  const [openDelete, setOpenDelete] = React.useState<boolean>(false);
  const [openDeleteObs, setOpenDeleteObs] = React.useState<boolean>(false);
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [editRow, setEditRow] = useState<boolean>(false);
  const [editRowObs, setEditRowObs] = useState<boolean>(false);
  const [showNewRow, setShowNewRow] = useState<boolean>(false);
  const [showObsRow, setShowObsRow] = useState<boolean>(false);

  const [editingId, setEditingId] = useState<number | undefined>();
  const [editingIdObs, setEditingIdObs] = useState<number | undefined>();

  const [rows, setRows] = useState<IPage5[]>([]);
  const [rows_filtrada, setRows_filtrada] = useState<IPage5[]>([]);

  const [newRow, setNewRow] = useState<IPage5 | undefined>();
  const [obsRow, setObsRow] = useState<IPage5Observacoes[]>([])
  const [observacoes, setObervacoes] = useState<IPage5Observacoes | undefined>();
  const [obj_anexo_cabecalho_selecionado, set_obj_anexo_cabecalho_selecionado] = useState<ICabecalho | undefined>();

  const camposNumericos = ["t", "m", "l", "k", "n", "po", "k2o", "mgo", "cao", "so"];
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handleCancel()

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };


  async function getOperacoesCulturais() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_operacoes_culturais_cabecalho/${obj_anexo_cabecalho_selecionado?.id_regsto_oper_cult_cabecalho}`);
      if (res.status === 200) {

        const formattedData = res.data.result.map(formatar_numeros_tabela5);
        setRows(formattedData);
        setRows_filtrada(formattedData);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getOperacoesCulturais", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  async function getOperacoesCulturaisObservacoes() {
    setIsLoading(true);
    try {

      let res = await get(auth.token.cookie_token, `/get_reg_operacoes_culturais_obs_cabecalho/${obj_anexo_cabecalho_selecionado?.id_regsto_oper_cult_cabecalho}`);
      if (res.status === 200) {
        setObsRow(res.data.result);

      }
      setIsLoading(false);
    } catch (error) {
      func_print("getOperacoesCulturais", error, true);
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      if (obj_anexo_cabecalho_selecionado !== undefined) {

        await getOperacoesCulturais();
        await getOperacoesCulturaisObservacoes();

        setNewRow((tab: any) => ({
          ...tab,
          id_regsto_oper_cult_cabecalho: obj_anexo_cabecalho_selecionado?.id_regsto_oper_cult_cabecalho
        }))
      } else {
        setIsLoading(false)
      }
    })();
  }, [obj_anexo_cabecalho_selecionado]);

  /********************** PÁGINA OPERAÇÕES CULTURAIS ******************************************************************/
  // CREATE NEW ROW
  const onInputChange = (event: any) => {
    const { name, value } = event.target;

    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)

    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "t") {
          set_error_t(false);
        } else if (name === "m") {
          set_error_m(false);
        } else if (name === "k") {
          set_error_k(false);
        } else if (name === "l") {
          set_error_l(false);
        } else if (name === "n") {
          set_error_n(false);
        } else if (name === "po") {
          set_error_po(false);
        } else if (name === "k2o") {
          set_error_k2o(false);
        } else if (name === "mgo") {
          set_error_mgo(false);
        } else if (name === "cao") {
          set_error_cao(false);
        } else if (name === "so") {
          set_error_lso(false);
        }
      } else {
        if (name === "t") {
          set_error_t(true);
        } else if (name === "m") {
          set_error_m(true);
        } else if (name === "l") {
          set_error_l(true);
        } else if (name === "k") {
          set_error_k(true);
        } else if (name === "n") {
          set_error_n(true);
        } else if (name === "po") {
          set_error_po(true);
        } else if (name === "k2o") {
          set_error_k2o(true);
        } else if (name === "mgo") {
          set_error_mgo(true);
        } else if (name === "cao") {
          set_error_cao(true);
        } else if (name === "so") {
          set_error_lso(true);
        }
      }
      setNewRow((prevNewRows: any) => ({
        ...prevNewRows,
        [name]: formatarNumero_ao_digitar(valorSemFormatar),
      }));
    } else {
      setNewRow((prevNewRows: any) => ({
        ...prevNewRows,
        [name]: value,
      }));
    }
  };

  const handleSave = async () => {

    if (
      !newRow?.data_inicio ||
      !newRow?.data_fim
    ) {
      setMessage("Selecione as datas de início e fim!");
      setOpenSnackError(true);
      return;
    }
    const dataInicio = new Date(newRow.data_inicio);
    const dataFim = new Date(newRow.data_fim);

    if (isNaN(dataInicio.getTime()) || isNaN(dataFim.getTime())) {
      setMessage("Datas inválidas!");
      setOpenSnackError(true);
      return;
    } else if (dataFim < dataInicio) {
      setMessage("A data de fim não pode ser anterior à data de início!");
      setOpenSnackError(true);
      return;
    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "new_reg_operacoes_culturais", {
          payload: {
            id_regsto_oper_cult: 0,
            data_inicio: newRow?.data_inicio === undefined ? "" : newRow.data_inicio,
            data_fim: newRow?.data_fim === undefined ? "" : newRow.data_fim,
            operacao_cultural: newRow?.operacao_cultural === undefined ? "" : newRow.operacao_cultural,
            ferilizante_utili: newRow?.ferilizante_utili === undefined ? "" : newRow.ferilizante_utili,
            modo_aplicacao: newRow?.modo_aplicacao === undefined ? "" : newRow.modo_aplicacao,
            t: newRow?.t === undefined ? null : desformatarNumero_return_null(newRow.t),
            m: newRow?.m === undefined ? null : desformatarNumero_return_null(newRow?.m),
            k: newRow?.k === undefined ? null : desformatarNumero_return_null(newRow.k),
            l: newRow?.l === undefined ? null : desformatarNumero_return_null(newRow?.l),
            n: newRow?.n === undefined ? null : desformatarNumero_return_null(newRow.n),
            po: newRow?.po === undefined ? null : desformatarNumero_return_null(newRow.po),
            k2o: newRow?.k2o === undefined ? null : desformatarNumero_return_null(newRow.k2o),
            mgo: newRow?.mgo === undefined ? null : desformatarNumero_return_null(newRow.mgo),
            cao: newRow?.cao === undefined ? null : desformatarNumero_return_null(newRow.cao),
            so: newRow?.so === undefined ? null : desformatarNumero_return_null(newRow?.so),
            inter_processos: newRow?.inter_processos === undefined ? "" : newRow.inter_processos,
            material_utilizado: newRow?.material_utilizado === undefined ? "" : newRow.material_utilizado,
            observacoes_objetivo: newRow?.observacoes_objetivo === undefined ? "" : newRow.observacoes_objetivo,
            debito_dia: newRow?.debito_dia === undefined ? "" : newRow.debito_dia,
            processo: newRow?.processo === undefined ? "" : newRow.processo,
            quantidade: newRow?.quantidade === undefined ? 0 : newRow.quantidade,
            quantificacao: newRow?.quantificacao === undefined ? "" : newRow.quantificacao,
            medida: newRow.medida === undefined ? "" : newRow.medida,
            id_regsto_oper_cult_cabecalho: obj_anexo_cabecalho_selecionado?.id_regsto_oper_cult_cabecalho,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);
          setShowNewRow(false);
          set_flag_editado(false)

          setNewRow(undefined);

          setRows((prevRows) => {
            if (prevRows !== undefined) {
              return [...prevRows, formatar_numeros_tabela5(res.data.result)]
            } else {
              return [formatar_numeros_tabela5(res.data.result)]
            }
          })
          setRows_filtrada((prevRows) => {
            if (prevRows !== undefined) {
              return [...prevRows, formatar_numeros_tabela5(res.data.result)]
            } else {
              return [formatar_numeros_tabela5(res.data.result)]
            }
          })
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error: any) {
        func_print("handleSave", error, true);
        if (error?.status === 409) {

          setMessage(error?.response.data.detail);
          setOpenSnackError(true);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }

        setIsLoading(false);
      }
    }
  };
  const handleCancel = () => {
    setShowNewRow(false);
    setNewRow(undefined);
    setObervacoes(undefined)
    setEditRow(false);
    setEditRowObs(false)
    setEditingId(undefined)
    setEditingIdObs(undefined)
    getOperacoesCulturais();
    getOperacoesCulturaisObservacoes();
  }

  // EDITAR LINHA 
  const handleEdit = (id: number | undefined) => {
    setEditingId(id);
    setEditRow(true);
  };
  const onInputChage_editar_linha = (event: any) => {
    const { name, value } = event.target;
    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)

    if (editingId !== undefined) {
      const updateRow = rows.map((row) => {
        if (row.id_regsto_oper_cult === editingId) {
          let updatedValues: any = { ...row, [name]: value };

          if (isCampoNumerico) {
            // Validação e formatação para campos numéricos para efetuar calculos
            const valorSemFormatar = value.replace(/[^\d,]/g, "");
            const valorNumerico = parseFloat(valorSemFormatar.replace(",", "."));

            if (!isNaN(valorNumerico)) {
              // Aplicar a formatação pt-PT 
              updatedValues[name] = formatarNumero_ao_digitar(valorSemFormatar);

              if (name === "t") {
                set_error_t(false);
              } else if (name === "m") {
                set_error_m(false);
              } else if (name === "k") {
                set_error_k(false);
              } else if (name === "l") {
                set_error_l(false);
              } else if (name === "n") {
                set_error_n(false);
              } else if (name === "po") {
                set_error_po(false);
              } else if (name === "k2o") {
                set_error_k2o(false);
              } else if (name === "mgo") {
                set_error_mgo(false);
              } else if (name === "cao") {
                set_error_cao(false);
              } else if (name === "so") {
                set_error_lso(false);
              }
            } else {
              if (name === "t") {
                set_error_t(true);
              } else if (name === "m") {
                set_error_m(true);
              } else if (name === "k") {
                set_error_k(true);
              } else if (name === "l") {
                set_error_l(true);
              } else if (name === "n") {
                set_error_n(true);
              } else if (name === "po") {
                set_error_po(true);
              } else if (name === "k2o") {
                set_error_k2o(true);
              } else if (name === "mgo") {
                set_error_mgo(true);
              } else if (name === "cao") {
                set_error_cao(true);
              } else if (name === "so") {
                set_error_lso(true);
              }
            }
            return updatedValues;
          } else {
            updatedValues[name] = value;
          }
          return updatedValues;
        }
        return row;
      });
      setRows(updateRow);
      setRows_filtrada(updateRow);
    }
  };

  const handleUpdate = async () => {
    if (editingId !== undefined) {
      const tableToSave = rows.find((tab) => tab.id_regsto_oper_cult === editingId);
      if (
        !tableToSave?.data_inicio ||
        !tableToSave?.data_fim
      ) {
        setMessage("Selecione as datas de início e fim!");
        setOpenSnackError(true);
        return;
      }
      const dataInicio = new Date(tableToSave.data_inicio);
      const dataFim = new Date(tableToSave.data_fim);

      if (isNaN(dataInicio.getTime()) || isNaN(dataFim.getTime())) {
        setMessage("Datas inválidas!");
        setOpenSnackError(true);
        return;
      } else if (dataFim < dataInicio) {
        setMessage("A data de fim não pode ser anterior à data de início!");
        setOpenSnackError(true);
        return;
      } else {
        if (tableToSave) {
          try {
            setIsLoading(true);

            const res = await post(auth.token.cookie_token, "/update_reg_operacoes_culturais", {
              payload: {
                id_regsto_oper_cult: tableToSave.id_regsto_oper_cult,
                data_inicio: tableToSave?.data_inicio === undefined ? "" : tableToSave.data_inicio,
                data_fim: tableToSave?.data_fim === undefined ? "" : tableToSave.data_fim,
                operacao_cultural: tableToSave?.operacao_cultural === undefined ? "" : tableToSave.operacao_cultural,
                ferilizante_utili: tableToSave?.ferilizante_utili === undefined ? "" : tableToSave.ferilizante_utili,
                modo_aplicacao: tableToSave?.modo_aplicacao === undefined ? "" : tableToSave.modo_aplicacao,
                t: tableToSave?.t === undefined ? null : desformatarNumero_return_null(tableToSave.t),
                m: tableToSave?.m === undefined ? null : desformatarNumero_return_null(tableToSave?.m),
                k: tableToSave?.k === undefined ? null : desformatarNumero_return_null(tableToSave.k),
                l: tableToSave?.l === undefined ? null : desformatarNumero_return_null(tableToSave?.l),
                n: tableToSave?.n === undefined ? null : desformatarNumero_return_null(tableToSave.n),
                po: tableToSave?.po === undefined ? null : desformatarNumero_return_null(tableToSave.po),
                k2o: tableToSave?.k2o === undefined ? null : desformatarNumero_return_null(tableToSave.k2o),
                mgo: tableToSave?.mgo === undefined ? null : desformatarNumero_return_null(tableToSave.mgo),
                cao: tableToSave?.cao === undefined ? null : desformatarNumero_return_null(tableToSave.cao),
                so: tableToSave?.so === undefined ? null : desformatarNumero_return_null(tableToSave.so),
                inter_processos: tableToSave?.inter_processos === undefined ? "" : tableToSave.inter_processos,
                material_utilizado: tableToSave?.material_utilizado === undefined ? "" : tableToSave.material_utilizado,
                observacoes_objetivo: tableToSave?.observacoes_objetivo === undefined ? "" : tableToSave.observacoes_objetivo,
                debito_dia: tableToSave?.debito_dia === undefined ? "" : tableToSave.debito_dia,
                processo: tableToSave?.processo === undefined ? "" : tableToSave.processo,
                quantidade: tableToSave?.quantidade === undefined ? "" : tableToSave.quantidade,
                quantificacao: tableToSave?.quantificacao === undefined ? "" : tableToSave.quantificacao,
                medida: tableToSave?.medida === undefined ? "" : tableToSave.medida,
                id_regsto_oper_cult_cabecalho: obj_anexo_cabecalho_selecionado?.id_regsto_oper_cult_cabecalho,
                last_update: tableToSave.last_update,
                create_date: tableToSave.create_date,
                uuid: tableToSave.uuid,
              }
            });
            if (res.status === 200) {
              setMessage("Registado com sucesso!");

              const updatedRows = rows.map((row) => {
                if (row.id_regsto_oper_cult === editingId) {
                  return formatar_numeros_tabela5(res.data.result);
                } else {
                  return row
                }
              });

              setRows(updatedRows !== undefined ? updatedRows : []);
              setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
              set_flag_editado(false)
              setEditRow(false);
              setEditingId(undefined);
              setOpenSnackSuccess(true);
            } else {
              setMessage("Erro ao gravar!");
              setOpenSnackError(true);
            }
            setIsLoading(false);

          } catch (error: any) {
            func_print("handleUpdate", error, true);
            if (error?.status === 409) {

              setMessage(error?.response.data.detail);
              setOpenSnackError(true);
            } else {
              setMessage("Erro ao efetuar a sua operação!");
              setOpenSnackError(true);
            }

            setIsLoading(false);
          }
        }
      }
    };
  };

  /*********** DELETE **************************/
  const handleClickOpenDelete = (idToDelete: number | undefined) => {
    setIdToDelete(idToDelete);
    setOpenDelete(true);
  };
  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_operacoes_culturais/${idToDelete}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDelete(false);
        setIdToDelete(undefined);
        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_regsto_oper_cult !== idToDelete),
        ]);
        setRows_filtrada((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_regsto_oper_cult !== idToDelete),
        ]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /**************** CAMPO OBSERVAÇÕES *********************/
  const onInputChange_Obs = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;

    setObervacoes((prevNewRows: any) => ({
      ...prevNewRows,
      [name]: value,
    }));
  };

  const handleSaveObs = async () => {
    if (observacoes?.obs === "" || observacoes?.obs === undefined) {
      setMessage("Preencha o campo Observações antes de gravar!");
      setOpenSnackError(true);
    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "new_reg_operacoes_culturais_obs", {
          payload: {
            id_regsto_oper_cult_obs: 0,
            obs: observacoes?.obs !== undefined ? observacoes.obs : "",
            id_regsto_oper_cult_cabecalho: obj_anexo_cabecalho_selecionado?.id_regsto_oper_cult_cabecalho,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);
          setShowObsRow(false);
          set_flag_editado(false)

          setObervacoes(undefined);
          setObsRow((prevRows) => {
            return [...prevRows, res.data.result];
          })
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error: any) {

        func_print("handleSave", error, true);
        // if (error?.status === 409) {

        //   setMessage(error?.response.data.detail);
        //   setOpenSnackError(true);
        // } else {
        //   setMessage("Erro ao efetuar a sua operação!");
        //   setOpenSnackError(true);
        // }
        if ((error as any)?.response?.data?.message) {
          setMessage((error as any).response.data.message);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
        }
        setOpenSnackError(true);

        setIsLoading(false);
      }
    }
  };

  // Edit
  const handleEditObs = (id: number | undefined) => {
    setEditingIdObs(id);
    setEditRowObs(true);
  };
  const onInputChage_editar_linhaObs = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;

    if (editingIdObs !== undefined) {
      const updateRow = obsRow.map((row) => {
        if (row.id_regsto_oper_cult_obs === editingIdObs) {
          return {
            ...row,
            [name]: value,
          };
        }
        return row;
      });
      setObsRow(updateRow);
    }
  };
  const handleUpdateObs = async () => {
    if (editingIdObs !== undefined) {
      const tableToSave = obsRow.find((tab) => tab.id_regsto_oper_cult_obs === editingIdObs);

      if (tableToSave) {
        try {
          setIsLoading(true);

          const res = await post(auth.token.cookie_token, "/update_reg_operacoes_culturais_obs", { payload: tableToSave });
          if (res.status === 200) {
            setMessage("Registado com sucesso!");

            const updatedRows = obsRow.map((row) => {
              if (row.id_regsto_oper_cult_obs === editingIdObs) {
                return res.data.result
              } else {
                return { ...row };
              }
            });

            setObsRow(updatedRows !== undefined ? updatedRows : []);
            set_flag_editado(false)
            setEditRowObs(false);
            setEditingIdObs(undefined);
            setOpenSnackSuccess(true);
          } else {
            setMessage("Erro ao gravar!");
            setOpenSnackError(true);
          }
          setIsLoading(false);

        } catch (error: any) {
          func_print("handleUpdateObs", error, true);
          if (error?.status === 409) {

            setMessage(error?.response.data.detail);
            setOpenSnackError(true);
          } else {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
          }

          setIsLoading(false);
        }
      }
    }
  };

  /*********** DELETE **************************/
  const handleClickOpenDeleteObs = (idToDelete: number | undefined) => {
    setIdToDelete(idToDelete);
    setOpenDeleteObs(true);
  };
  const handleDeleteObs = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_operacoes_culturais_obs/${idToDelete}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDeleteObs(false);
        setIdToDelete(undefined);
        setObsRow((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_regsto_oper_cult_obs !== idToDelete),
        ]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteObs", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  /**************** PAGINAÇÃO *********************/
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  return (
    <CustomThemeProvider>
      <div className={classes.root}>
        <CadernoLayout title="5 - Registo de Operações Culturais" />
        <main className={classes.contents}>
          <div className={classes.toolbars} />

          <Box width="80%" margin="auto">
            <BeneficiarioNomeIdAlinhadoDireita />
          </Box>
          <FilterByData
              listas={[
                {
                  lista_original: rows,
                  set_lista_filtrada: setRows_filtrada,
                  campoData: "data_inicio",
                },
               
              ]}
            />
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>

          <Box style={{ width: "100%", height: "auto" }}>
            <CabecalhoForm
              obj_anexo_cabecalho_selecionado={obj_anexo_cabecalho_selecionado}
              set_obj_anexo_cabecalho_selecionado={set_obj_anexo_cabecalho_selecionado}
            />
          </Box>

          {isLoading ? (
            <LoadingVulpes />
          ) : (
            obj_anexo_cabecalho_selecionado !== undefined ?

              <>
                <TableContainer
                  component={Paper}
                  sx={{
                    height: "auto",
                    width: "auto",
                    margin: 2,
                    padding: 2,
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={21}>
                          <Box
                            sx={{ display: "flex", justifyContent: "end", }} >
                            {
                              is_historico === true ? <></> :

                                <BarraDeFerramentas
                                  mostrarBotaoNovo
                                  textoBotaoNovo="Novo Registo"
                                  aoClicarNovo={() => {
                                    setShowNewRow(true)
                                    setEditingId(undefined)
                                    setEditingIdObs(undefined)
                                  }} />
                            }
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead colSpan={15}>
                          Fertilização
                        </StyledTableHead>
                        <StyledTableHead colSpan={3}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Prática Cultural
                            <BasicPopover
                              text={"Entende-se por Prática cultural todo o tipo de intervenção efetuado ao nível da parcela agrícola ou cultura,\n como por exemplo a utilização de cultivares resistentes e ou material de propagação vegetativa categoria normalizada ou certificada,\n controlo de infestantes, como a monda manual, mobilização do solo, limpeza e preparação do terreno. \nIncluir também a rotação de culturas, podas sanitárias, destruição e queima da lenha,\n desinfeção de utensílios, entre outros.\n Preenchimento obrigatório apenas para os beneficiários de PRODI."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Rega
                            <BasicPopover text={"No caso de rega diária com dotações constantes, indicar as datas do início, fim,\n e as alterações intermédias dos débitos. Sempre que possível incluir a justificação\n das dotações de rega."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead colSpan={3}>Colheita</StyledTableHead>
                        <StyledTableHead rowSpan={3}>Ações</StyledTableHead>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 100 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Data Início*
                            <BasicPopover text={"As regas poderão estar agrupadas por períodos mensais, quinzenais, semanais, ou outros.\n As restantes operações devem ser registadas por dia."} />
                          </Stack>
                        </StyledTableHead>

                        <StyledTableHead rowSpan={2} sx={{ minWidth: 100 }}>

                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Data Fim*
                            <BasicPopover text={"As regas poderão estar agrupadas por períodos mensais, quinzenais, semanais, ou outros.\n As restantes operações devem ser registadas por dia."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}>
                          Operação
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            cultural
                            <BasicPopover text={"O beneficiário deverá preencher com um dos seguintes valores por linha (data da aplicação): \n Aplicação de corretivos \n Fertilização fundo \n Adubação verde \n Aplicação de estrume \n Aplicação de chorume \n Fertilização cobertura \n Fertirrigação \n O beneficiário deverá preencher este campo com as operações de fertilização previstas no Plano de Fertilização (Anexo 1) quando realizadas."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}>
                          Fertilizante
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            utilizado
                            <BasicPopover text={"No caso de adução verde identificar as espécies incorporadas no solo."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}>
                          Modo de
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            aplicação
                            <BasicPopover text={"Não preencher no caso da fertirrega."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead colSpan={4}>Quantidade Aplicada </StyledTableHead>
                        <StyledTableHead colSpan={6}> Aplicação de nutrientes (Kg) </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}>Intervenção ou processos </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}> Material ou equipamento utilizado </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}> Observações / Objetivos </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 180 }}>Débito/dia ou dotação total da rega </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>Processo</StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>Quantidade (kg)</StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}> Quantificação (Lote nº) </StyledTableHead>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead sx={{ minWidth: 70 }}> t </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> m3 </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> k </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> l </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> N </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> P2O5 </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> K2O </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> MgO </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> CaO </StyledTableHead>
                        <StyledTableHead sx={{ minWidth: 70 }}> SO3 </StyledTableHead>
                        <StyledTableHead>(mm/m2 ou m3/ha))</StyledTableHead>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {showNewRow && (
                        <TableRow>
                          <StyledTableCell>
                            <TextField
                              variant="filled"
                              name="data_inicio"
                              type="date"
                              inputProps={{ style: { fontSize: 12, fontFamily: "verdana" }, }}
                              InputLabelProps={{ shrink: true, }}
                              value={newRow?.data_inicio !== undefined ? newRow.data_inicio : ""}
                              onChange={(e: ChangeEvent<HTMLInputElement>) => onInputChange(e)} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <TextField
                              variant="filled"
                              name="data_fim"
                              type="date"
                              inputProps={{ style: { fontSize: 12, fontFamily: "verdana" }, }}
                              InputLabelProps={{ shrink: true, }}
                              value={newRow?.data_fim !== undefined ? newRow.data_fim : ""}
                              onChange={(e: ChangeEvent<HTMLInputElement>) => onInputChange(e)} />
                          </StyledTableCell>
                          <StyledTableCell>
                            {/* <CustomSelect
                              value={newRow?.operacao_cultural !== undefined ? newRow.operacao_cultural : ""}
                              name="operacao_cultural"
                              onChange={onInputChange}
                              options={operacaocultural}
                              label="Operação Cultural"
                              minWidth={150} />
                               */}
                            <CreatableSelect
                              formatCreateLabel={(inputValue) => `Criar "${inputValue}"`}

                              placeholder={'Selecionar'}
                              components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                              noOptionsMessage={() => "Não encontrado"}
                              menuPosition="absolute"
                              menuShouldScrollIntoView={false}
                              styles={{
                                menuPortal: base => ({
                                  ...base,
                                  fontSize: 14
                                }),

                                option: (styles, state) => ({
                                  ...styles,
                                  color: state.isSelected ? 'white' : 'black',
                                  fontSize: 14,
                                  backgroundColor: state.isSelected ? cores.cor1 : 'white',
                                  '&:hover': {
                                    backgroundColor: cores.cor3,
                                    color: 'white',
                                  }

                                }),

                                control: base => ({
                                  ...base,
                                  fontSize: 14,

                                  height: 50,
                                  minHeight: 10,
                                  width: 200,
                                  alignItems: 'center',
                                  paddingTop: 0,
                                  marginTop: 0,
                                  boxShadow: 'none',
                                  border: `1px solid silver`,
                                  '&:hover': {
                                    border: '1px solid silver',
                                  }
                                }),

                                input: (provided, state) => ({
                                  ...provided,
                                  fontSize: 14,
                                  paddingTop: 0,
                                  marginTop: 0,

                                }),

                              }}
                              onChange={(e: any) => {
                                if (e.label === e.value) {
                                  setNewRow((prevnewRow: any) => ({
                                    ...prevnewRow,
                                    ['operacao_cultural']: e.label,
                                  }));

                                } else {

                                  setNewRow((prevnewRow: any) => ({
                                    ...prevnewRow,
                                    ['operacao_cultural']: e.label,
                                  }));

                                }
                              }}
                              options={operacaocultural_aux}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="ferilizante_utili"
                              value={newRow?.ferilizante_utili === undefined ? "" : newRow.ferilizante_utili}
                              onChange={onInputChange} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="modo_aplicacao"
                              value={newRow?.modo_aplicacao === undefined ? "" : newRow.modo_aplicacao}
                              onChange={onInputChange} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="t"
                              value={newRow?.t === undefined ? "" : newRow.t}
                              onChange={onInputChange}
                              error={error_t}
                              helperText={error_t ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="m"
                              value={newRow?.m === undefined ? "" : newRow.m}
                              onChange={onInputChange}
                              error={error_m}
                              helperText={error_m ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="k"
                              value={newRow?.k === undefined ? "" : newRow.k}
                              onChange={onInputChange}
                              error={error_k}
                              helperText={error_k ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="l"
                              value={newRow?.l === undefined ? "" : newRow.l}
                              onChange={onInputChange}
                              error={error_l}
                              helperText={error_l ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="n"
                              value={newRow?.n === undefined ? "" : newRow.n}
                              onChange={onInputChange}
                              error={error_n}
                              helperText={error_n ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="po"
                              value={newRow?.po === undefined ? "" : newRow.po}
                              onChange={onInputChange}
                              error={error_po}
                              helperText={error_po ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="k2o"
                              value={newRow?.k2o === undefined ? "" : newRow.k2o}
                              onChange={onInputChange}
                              error={error_k2o}
                              helperText={error_k2o ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="mgo"
                              value={newRow?.mgo === undefined ? "" : newRow.mgo}
                              onChange={onInputChange}
                              error={error_mgo}
                              helperText={error_mgo ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="cao"
                              value={newRow?.cao === undefined ? "" : newRow.cao}
                              onChange={onInputChange}
                              error={error_cao}
                              helperText={error_cao ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="so"
                              value={newRow?.so === undefined ? "" : newRow.so}
                              onChange={onInputChange}
                              error={error_so}
                              helperText={error_so ? message_apenas_numero : ""} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="inter_processos"
                              value={newRow?.inter_processos === undefined ? "" : newRow.inter_processos}
                              onChange={onInputChange} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="material_utilizado"
                              value={newRow?.material_utilizado === undefined ? "" : newRow.material_utilizado}
                              onChange={onInputChange} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="observacoes_objetivo"
                              value={newRow?.observacoes_objetivo === undefined ? "" : newRow.observacoes_objetivo}
                              onChange={onInputChange} />
                          </StyledTableCell>
                          <StyledTableCell sx={{ minWidth: 200 }}>
                            <Stack direction="row" alignItems="center" >
                              <CustomTextField
                                name="debito_dia"
                                value={newRow?.debito_dia === undefined ? "" : newRow.debito_dia}
                                onChange={onInputChange} />
                              <CustomSelect
                                value={newRow?.medida !== undefined ? newRow.medida : ""}
                                name="medida"
                                onChange={onInputChange}
                                options={unidade_medida_mm}
                                label="UM"
                                minWidth={50}
                              />
                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="processo"
                              value={newRow?.processo === undefined ? "" : newRow.processo}
                              onChange={onInputChange} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="quantidade"
                              value={newRow?.quantidade === undefined ? 0 : newRow.quantidade}
                              onChange={onInputChange} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="quantificacao"
                              value={newRow?.quantificacao === undefined ? "" : newRow.quantificacao}
                              onChange={onInputChange} />
                          </StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center">
                              <ButtonCadernos
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => {
                                  if (flag_editado) {
                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                  } else {
                                    handleCancel()
                                  }
                                }}
                                mostrarBotaoGravar
                                aoClicarGravar={() => handleSave()} />
                            </Stack>
                          </StyledTableCell>
                        </TableRow>
                      )}
                      {(rowsPerPage > 0
                        ? rows_filtrada.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        : rows_filtrada
                      ).sort((a, b) => {
                        const dataA = a.data_inicio ? new Date(a.data_inicio).getTime() : 0;
                        const dataB = b.data_inicio ? new Date(b.data_inicio).getTime() : 0;

                        return dataA - dataB; // mais antiga -> mais recente
                      }).map((row, index) => {
                        // const selectedValueRow = operacaocultural.includes(row.operacao_cultural !== undefined ? row.operacao_cultural : "")
                        //   ? row.operacao_cultural
                        //   : "";

                        return (
                          <TableRow key={index}>
                            {editingId === row.id_regsto_oper_cult && editRow ? (
                              <React.Fragment>
                                <StyledTableCell>
                                  <TextField
                                    variant="filled"
                                    name="data_inicio"
                                    type="date"
                                    value={row.data_inicio}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => onInputChage_editar_linha(e)} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <TextField
                                    variant="filled"
                                    name="data_fim"
                                    type="date"
                                    value={row.data_fim}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => onInputChage_editar_linha(e)} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  {/* <CustomSelect
                                    value={row.operacao_cultural !== undefined ? row.operacao_cultural : ""}
                                    name="operacao_cultural"
                                    onChange={onInputChage_editar_linha}
                                    options={operacaocultural}
                                    label="Operação Cultural"
                                    minWidth={120} /> */}

                                  <CreatableSelect
                                    formatCreateLabel={(inputValue) => `Criar "${inputValue}"`}

                                    placeholder={'Selecionar'}
                                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                    noOptionsMessage={() => "Não encontrado"}
                                    menuPosition="absolute"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                      menuPortal: base => ({
                                        ...base,
                                        fontSize: 14
                                      }),

                                      option: (styles, state) => ({
                                        ...styles,
                                        color: state.isSelected ? 'white' : 'black',
                                        fontSize: 14,
                                        backgroundColor: state.isSelected ? cores.cor1 : 'white',
                                        '&:hover': {
                                          backgroundColor: cores.cor3,
                                          color: 'white',
                                        }

                                      }),

                                      control: base => ({
                                        ...base,
                                        fontSize: 14,

                                        height: 50,
                                        minHeight: 10,
                                        width: 200,
                                        alignItems: 'center',
                                        paddingTop: 0,
                                        marginTop: 0,
                                        boxShadow: 'none',
                                        border: `1px solid silver`,
                                        '&:hover': {
                                          border: '1px solid silver',
                                        }
                                      }),

                                      input: (provided, state) => ({
                                        ...provided,
                                        fontSize: 14,
                                        paddingTop: 0,
                                        marginTop: 0,

                                      }),

                                    }}
                                    onChange={(e: any) => {
                                      const updateRow = rows.map((row) => {
                                        if (row.id_regsto_oper_cult === editingId) {
                                          let updatedValues: any = {}
                                          if (e.label === e.value) {
                                            updatedValues = { ...row, ['operacao_cultural']: e.label }
                                          } else {
                                            updatedValues = { ...row, ['operacao_cultural']: e.label }
                                          }
                                          return updatedValues;
                                        }
                                        return row;
                                      });
                                      setRows(updateRow);
                                      setRows_filtrada(updateRow);

                                    }}
                                    options={operacaocultural_aux}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="ferilizante_utili"
                                    value={row.ferilizante_utili !== undefined ? row.ferilizante_utili : ""}
                                    onChange={onInputChage_editar_linha} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="modo_aplicacao"
                                    value={row.modo_aplicacao}
                                    onChange={onInputChage_editar_linha} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="t"
                                    value={row.t}
                                    onChange={onInputChage_editar_linha}
                                    error={error_t}
                                    helperText={error_t ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="m"
                                    value={row.m}
                                    onChange={onInputChage_editar_linha}
                                    error={error_m}
                                    helperText={error_m ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="k"
                                    value={row.k}
                                    onChange={onInputChage_editar_linha}
                                    error={error_k}
                                    helperText={error_k ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="l"
                                    value={row.l}
                                    onChange={onInputChage_editar_linha}
                                    error={error_l}
                                    helperText={error_l ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="n"
                                    value={row.n}
                                    onChange={onInputChage_editar_linha}
                                    error={error_n}
                                    helperText={error_n ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="po"
                                    value={row.po}
                                    onChange={onInputChage_editar_linha}
                                    error={error_po}
                                    helperText={error_po ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="k2o"
                                    value={row.k2o}
                                    onChange={onInputChage_editar_linha}
                                    error={error_k2o}
                                    helperText={error_k2o ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="mgo"
                                    value={row.mgo}
                                    onChange={onInputChage_editar_linha}
                                    error={error_mgo}
                                    helperText={error_mgo ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="cao"
                                    value={row.cao}
                                    onChange={onInputChage_editar_linha}
                                    error={error_cao}
                                    helperText={error_cao ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="so"
                                    value={row.so}
                                    onChange={onInputChage_editar_linha}
                                    error={error_so}
                                    helperText={error_so ? message_apenas_numero : ""} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="inter_processos"
                                    value={row.inter_processos}
                                    onChange={onInputChage_editar_linha} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="material_utilizado"
                                    value={row.material_utilizado}
                                    onChange={onInputChage_editar_linha} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="observacoes_objetivo"
                                    value={row.observacoes_objetivo}
                                    onChange={onInputChage_editar_linha} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <Stack direction="row" alignItems="center">
                                    <CustomTextField
                                      name="debito_dia"
                                      value={row.debito_dia}
                                      onChange={onInputChage_editar_linha} />
                                    <CustomSelect
                                      value={row?.medida !== undefined ? row.medida : ""}
                                      name="medida"
                                      onChange={onInputChage_editar_linha}
                                      options={unidade_medida_mm}
                                      label="UM"
                                      minWidth={50}
                                    />
                                  </Stack>
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="processo"
                                    value={row.processo}
                                    onChange={onInputChage_editar_linha} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="quantidade"
                                    value={row.quantidade}
                                    onChange={onInputChage_editar_linha} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="quantificacao"
                                    value={row.quantificacao}
                                    onChange={onInputChage_editar_linha} />
                                </StyledTableCell>
                              </React.Fragment>
                            ) : (
                              <>
                                <StyledTableCell>{row.data_inicio}</StyledTableCell>
                                <StyledTableCell>{row.data_fim}</StyledTableCell>
                                <StyledTableCell> {row.operacao_cultural}</StyledTableCell>
                                <StyledTableCell> {row.ferilizante_utili} </StyledTableCell>
                                <StyledTableCell> {row.modo_aplicacao} </StyledTableCell>
                                <StyledTableCell>{row.t} </StyledTableCell>
                                <StyledTableCell>{row.m} </StyledTableCell>
                                <StyledTableCell>{row.k} </StyledTableCell>
                                <StyledTableCell>{row.l} </StyledTableCell>
                                <StyledTableCell>{row.n} </StyledTableCell>
                                <StyledTableCell>{row.po} </StyledTableCell>
                                <StyledTableCell>{row.k2o} </StyledTableCell>
                                <StyledTableCell>{row.mgo} </StyledTableCell>
                                <StyledTableCell>{row.cao} </StyledTableCell>
                                <StyledTableCell>{row.so} </StyledTableCell>
                                <StyledTableCell> {row.inter_processos} </StyledTableCell>
                                <StyledTableCell>  {row.material_utilizado} </StyledTableCell>
                                <StyledTableCell> {row.observacoes_objetivo} </StyledTableCell>
                                <StyledTableCell> {row.debito_dia} {row.medida}  </StyledTableCell>
                                <StyledTableCell>{row.processo} </StyledTableCell>
                                <StyledTableCell>{row.quantidade} </StyledTableCell>
                                <StyledTableCell> {row.quantificacao} </StyledTableCell>
                              </>
                            )}
                            {editingId === row.id_regsto_oper_cult && editRow ? (
                              <StyledTableCell>
                                <ButtonCadernos
                                  mostrarBotaoGravar
                                  aoClicarGravar={() => handleUpdate()}
                                  mostrarBotaoCancelar
                                  aoClicarCancelar={() => {
                                    if (flag_editado) {
                                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                    } else {
                                      handleCancel()
                                    }
                                  }} />
                              </StyledTableCell>
                            ) : (
                              <StyledTableCell>
                                {
                                  is_historico === true ? <></> :
                                    <ButtonCadernos
                                      mostrarBotaoEditar
                                      aoClicarEditar={() => {
                                        setShowNewRow(false)
                                        handleEdit(row.id_regsto_oper_cult)
                                      }}
                                      mostrarBotaoApagar
                                      aoClicarApagar={() => handleClickOpenDelete(row.id_regsto_oper_cult)} />
                                }
                              </StyledTableCell>
                            )}
                          </TableRow>
                        );
                      })}

                      {obsRow.length <= 0 ?
                        (showObsRow ?
                          <TableRow>
                            <StyledTableHead>Observações</StyledTableHead>
                            <StyledTableCell colSpan={21}>
                              <CustomTextField
                                name="obs"
                                value={observacoes?.obs === undefined ? "" : observacoes.obs}
                                onChange={onInputChange_Obs} />
                            </StyledTableCell>
                            <StyledTableCell>
                              <Stack direction="row" justifyContent="center">
                                <ButtonCadernos
                                  mostrarBotaoCancelar
                                  aoClicarCancelar={() => {
                                    if (flag_editado) {
                                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                    } else {
                                      handleCancel()
                                    }
                                  }}
                                  mostrarBotaoGravar
                                  aoClicarGravar={() => handleSaveObs()} />
                              </Stack>
                            </StyledTableCell>
                          </TableRow>
                          :
                          <TableRow>
                            <StyledTableHead>Observações</StyledTableHead>
                            <StyledTableCell colSpan={21}>{observacoes?.obs === undefined ? "" : observacoes.obs}
                            </StyledTableCell>
                            <TableCell>
                              <Box sx={{ display: "flex", justifyContent: "end", }}  >
                                {
                                  is_historico === true ? <></> :

                                    <BarraDeFerramentas
                                      mostrarBotaoNovo
                                      textoBotaoNovo="Registar Observações"
                                      aoClicarNovo={() => setShowObsRow(true)} />
                                }
                              </Box>
                            </TableCell>
                          </TableRow>
                        )
                        :
                        (obsRow.map((obs, key) => <TableRow key={key}>
                          {editingIdObs === obs.id_regsto_oper_cult_obs && editRowObs ? (
                            <>
                              <StyledTableHead>Observações</StyledTableHead>
                              <StyledTableCell colSpan={21}>
                                <CustomTextField
                                  name="obs"
                                  value={obs.obs}
                                  onChange={onInputChage_editar_linhaObs} />
                              </StyledTableCell>
                            </>
                          ) : (
                            <>
                              <StyledTableHead>Observações</StyledTableHead>
                              <StyledTableCell colSpan={21} style={{ textAlign: "left" }} >
                                {obs.obs}
                              </StyledTableCell>
                            </>
                          )}
                          {editRowObs ? (
                            <StyledTableCell>
                              <ButtonCadernos
                                mostrarBotaoGravar
                                aoClicarGravar={handleUpdateObs}
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => {
                                  if (flag_editado) {
                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                  } else {
                                    handleCancel()
                                  }
                                }} />
                            </StyledTableCell>
                          ) : (
                            <StyledTableCell>
                              {
                                is_historico === true ? <></> :
                                  <ButtonCadernos
                                    mostrarBotaoEditar
                                    aoClicarEditar={() => handleEditObs(obs.id_regsto_oper_cult_obs)}
                                    mostrarBotaoApagar
                                    aoClicarApagar={() => handleClickOpenDeleteObs(obs.id_regsto_oper_cult_obs)} />
                              }
                            </StyledTableCell>
                          )}
                        </TableRow>

                        )
                        )}


                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={20} />
                        </TableRow>
                      )}
                    </TableBody>
                    <TableFooter>
                      <TableRow sx={{ width: "100%" }}>
                        <TableCell colSpan={6}>
                          <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                            * Campos de preenchimento obrigatório
                          </Typography>
                        </TableCell>
                        <TablePagination
                          rowsPerPageOptions={[
                            5,
                            10,
                            25,
                            { label: "All", value: -1 },
                          ]}
                          colSpan={13}
                          count={rows.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          labelDisplayedRows={({ from, to, count }) => {
                            return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                          }}
                          labelRowsPerPage={'Linhas por página'}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions} />
                      </TableRow>
                    </TableFooter>
                  </table>
                </TableContainer>
              </>
              :
              <></>
          )}

          <ConfirmDialog
            open={openDelete}
            onClose={() => setOpenDelete(false)}
            onConfirm={handleDelete}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={openDeleteObs}
            onClose={() => setOpenDeleteObs(false)}
            onConfirm={handleDeleteObs}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />
        </main>
      </div>
    </CustomThemeProvider>
  );
}
